import baseTheme from '../baseTheme';
var MuiTab = {
    root: {
        fontWeight: 700,
        letterSpacing: 1.2,
        maxWidth: 480,
        paddingLeft: baseTheme.spacing(2),
        paddingRight: baseTheme.spacing(2),
        '&': {
            minWidth: 'auto',
        },
        '&$selected': {
            color: baseTheme.palette.primary.main,
        },
        '&$disabled': {},
    },
    wrapper: {
        alignItems: 'flex-start',
    },
};
export default MuiTab;
//# sourceMappingURL=MuiTab.js.map